import React from 'react';
import { BoxHeader, DefaultBox } from '../common/DefaultBox';
import bitcoin from '../../assets/sidebar/bitcoin.svg';
import atriom from '../../assets/money icon/atriom.svg';
import cash from '../../assets/money icon/cash.svg';
import teter from '../../assets/money icon/Group 159.svg';
import lightcoin from '../../assets/money icon/light coin.svg';
import repel from '../../assets/money icon/repel.svg';
import wallet from '../../assets/sidebar/Wallet.svg';
const YourStockBox = () => {
    const items = [
        {
            id: 1,
            src: bitcoin,
            Arz: 'بیت کوین',
            cost: '17.870.000',
        },
        {
            id: 2,
            src: atriom,
            Arz: 'آتریوم ',
            cost: '81.71',
        },
        {
            id: 3,
            src: cash,
            Arz: 'بیت کوین کش',
            cost: '81.71',
        },
        {
            id: 4,
            src: teter,
            Arz: ' تتر',
            cost: '1',
        },
    ];
    return (
        <DefaultBox className="BBit-default-box your-stock-box ">
            <BoxHeader className="BBit-default-box-header " title="  موجودی های شما " icon={wallet} />

            <div className="your-stock-box-table-head">
                <p className="d-flex title-td">نوع ارز</p>
                <p>مقدار</p>
            </div>

            {items.map((i) => (
                <div key={i.id} className="your-stock-box-table-body">
                    <div className="d-flex title-td">
                        <img src={i.src} alt={i.Arz} />
                        <p>{i.Arz}</p>
                    </div>
                    <p>{i.cost}</p>
                </div>
            ))}
        </DefaultBox>
    );
};

export default YourStockBox;
